import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useCreateJobCatalogAttribute from 'modules/job_catalog/hooks/useCreateJobCatalogAttribute'
import useDeleteJobCatalogAttribute from 'modules/job_catalog/hooks/useDeleteJobCatalogAttribute'
import useUpdateJobCatalogAttribute from 'modules/job_catalog/hooks/useEditJobCatalogAttribute'
import { Salary } from 'modules/job_catalog/lib/salary'

export const useSalaryActions = () => {
  const { company } = useCurrentSession()

  const { createSalary } = useCreateJobCatalogAttribute()
  const { updateSalary } = useUpdateJobCatalogAttribute()
  const { deleteAttribute } = useDeleteJobCatalogAttribute()

  const handleCreateSalary = async (salary: Salary, nodeUuid: string) => {
    const result = await createSalary(company.id, nodeUuid, JSON.stringify(salary))
    const handled = handleResult(result, (resultErrors) => {
      app.setFlash({
        type: 'wrong',
        message: resultErrors.errors || i18n.t('errors.generic_error'),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('job_catalog.nodes.salary_modal.success'),
        time: 5000,
      })
    }

    return handled.success
  }

  const handleUpdateSalary = async (salary: Salary, nodeUuid: string) => {
    if (!salary.id) return false

    const result = await updateSalary(salary.id, company.id, nodeUuid, JSON.stringify(salary))
    const handled = handleResult(result, (resultErrors) => {
      app.setFlash({
        type: 'wrong',
        message: resultErrors.errors || i18n.t('errors.generic_error'),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('job_catalog.nodes.salary_modal.success'),
        time: 5000,
      })
    }

    return handled.success
  }

  const handleDeleteSalary = async (salary: Salary, nodeUuid: string) => {
    if (!salary.id) return false

    const result = await deleteAttribute(salary.id, nodeUuid)
    const handled = handleResult(result, (resultErrors) => {
      app.setFlash({
        type: 'wrong',
        message: resultErrors.errors || i18n.t('errors.generic_error'),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('job_catalog.nodes.salaries.delete_success'),
        time: 5000,
      })
    }

    return handled.success
  }

  return {
    handleCreateSalary,
    handleUpdateSalary,
    handleDeleteSalary,
  }
}
